import { render, staticRenderFns } from "./ResetPass1.vue?vue&type=template&id=72f2ca2a&scoped=true&"
import script from "./ResetPass1.vue?vue&type=script&lang=js&"
export * from "./ResetPass1.vue?vue&type=script&lang=js&"
import style0 from "./ResetPass1.vue?vue&type=style&index=0&id=72f2ca2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f2ca2a",
  null
  
)

export default component.exports